import {
  SocialExtractionResumeResponseSchema,
  SocialExtractionStartResponseSchema,
  SocialExtractionStopResponseSchema,
  type SocialProfileCreateRequest,
  SocialProfileResponseSchema,
  SocialWorkspaceResponseSchema,
} from "contracts/api/social/admin";
import { SocialReportResponseSchema } from "contracts/api/social/report";
import { request } from "./api-client";
import { requireSocial } from "./demo";

export const socialApi = {
  readSocialReport: (clientId: string) => {
    requireSocial();
    return request(
      "GET",
      `/api/clients/${clientId}/social-report`,
      SocialReportResponseSchema,
    );
  },
  readSocialWorkspace: (clientId: string) => {
    requireSocial();
    return request(
      "GET",
      `/api/admin/social?clientId=${encodeURIComponent(clientId)}`,
      SocialWorkspaceResponseSchema,
    );
  },
  registerSocialProfile: (input: SocialProfileCreateRequest) => {
    requireSocial();
    return request(
      "POST",
      "/api/admin/social/profiles",
      SocialProfileResponseSchema,
      input,
    );
  },
  startSocialExtraction: (profileId: string) => {
    requireSocial();
    return request(
      "POST",
      `/api/admin/social/profiles/${profileId}/extractions`,
      SocialExtractionStartResponseSchema,
    );
  },
  stopSocialExtraction: (runId: string) => {
    requireSocial();
    return request(
      "POST",
      `/api/admin/social/extractions/${runId}/stop`,
      SocialExtractionStopResponseSchema,
    );
  },
  resumeSocialExtraction: (runId: string) => {
    requireSocial();
    return request(
      "POST",
      `/api/admin/social/extractions/${runId}/resume`,
      SocialExtractionResumeResponseSchema,
    );
  },
};
